import * as React from 'react';
import PropTypes from 'prop-types';
import MDTypography from 'components/MDTypography';
import typography from 'assets/theme/base/typography';
import { useIntl } from 'react-intl';
import Link from '@mui/material/Link';

Copyright.propTypes = {
  align: PropTypes.string,
  light: PropTypes.bool
};

Copyright.defaultProps = {
  align: 'center'
};

export function Copyright({ align, light, ...other }) {
  const { formatMessage: msg } = useIntl();

  const { size } = typography;

  return (
    <MDTypography
      fontWeight="medium"
      color={light ? 'white' : 'text'}
      fontSize={size.sm}
      align={align}
      {...other}
    >
      &copy; {new Date().getFullYear()}{' '}
      <Link href={msg({ id: 'product.website' })} target="_blank">
        &nbsp;{msg({ id: 'product.name' })}&nbsp;
      </Link>
    </MDTypography>
  );
}
